import { render, staticRenderFns } from "./ReviseSalaryApproval.vue?vue&type=template&id=1d58a8ec&scoped=true"
import script from "./ReviseSalaryApproval.vue?vue&type=script&lang=js"
export * from "./ReviseSalaryApproval.vue?vue&type=script&lang=js"
import style0 from "./ReviseSalaryApproval.vue?vue&type=style&index=0&id=1d58a8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d58a8ec",
  null
  
)

export default component.exports